import { getBestCandidate } from "../spatialNavigation/index.js";
export function getClosestFocusableNodeInDirection(focusableNodes, focusOrigin, direction) {
    const focusableNodesArray = Array.from(focusableNodes.values());
    const nodeBoxes = focusableNodesArray.map((node) => node.getBoundingBox());
    const bestChildCandidateBox = getBestCandidate(focusOrigin, nodeBoxes, direction);
    if (!bestChildCandidateBox)
        return undefined;
    return focusableNodesArray[nodeBoxes.indexOf(bestChildCandidateBox)];
}
